<template>
  <div class="material-group-uploader">
    <el-upload ref="uploadRef"
               action=""
               :on-change="onFileChange"
               :on-remove="onFileRemove"
               :show-file-list="false"
               :auto-upload="false" accept=".psd" :disabled="loading">
      <slot :loading="loading">
        <el-button :type="type" round :loading="loading" :disabled="loading" title="请上传psd文件">上传<i class="el-icon-upload2"></i></el-button>
      </slot>
    </el-upload>
    <div v-if="dataList.length" class="h2canvas-div">
      <img-template :ref="`imgItemRef${index}`" :data="item" v-for="(item, index) in dataList" :key="index"></img-template>
    </div>
  </div>
</template>
<script>
  import imgTemplate from '../img-template/index'
  import fileService from '../../../request/service/fileupload-service'
  import groupService from '../../../request/service/group-service'
  import util from '@/util.js';
  import {group_type_pt} from '@/const.js';

  export default {
    components: {imgTemplate},
    props: {
      projectId: {String, default: ''},
      templateId: {String, default: ''},
      autoSave: {type: Boolean, default: true},
      type: {type: String, default: 'primary'}
    },
    data () {
      return {
        dataList: [],
        loading: false
      }
    },
    methods: {
      allowDrop (ev) {
        ev.preventDefault();
      },
      onDrop (evt) {
        // eslint-disable-next-line
        PSD.fromEvent(evt).then((psd) => {
          try {
            let pdsTree = psd.tree();
            let dataList = this.getImgs(pdsTree);
            if (dataList.length === 0) {
              this.$message.error('psd文件不符合要求');
              this.loading = false;
              return;
            }
            this.saveImgs(dataList);
          } catch (e) {
            console.error(e);
            this.$message.error('psd文件解析异常')
            this.loading = false;
          }
        });
      },
      saveImgs (imgList) {
        this.dataList = imgList;
        this.$nextTick(() => {
          this.setImgUrl(imgList).then(() => {
            if (this.autoSave) {
              this.save(imgList).then(() => {
                this.$emit('onCompleted', imgList);
                this.$message.success('上传成功')
              });
            } else {
              this.$emit('onCompleted', imgList);
            }
          }).finally(() => {
            this.loading = false;
            this.$refs.uploadRef && this.$refs.uploadRef.clearFiles();
            this.dataList = [];
          });
        });
      },
      async save (dataList) {
        await groupService.addGroup(dataList, this.projectId);
      },
      async setImgUrl (dataList) {
        let idx = 0;
        for (let item of dataList) {
          let canvas = await util.html2canvas(this.$refs[`imgItemRef${idx}`][0].$el, item.json.width, item.json.height);
          let {url} = await fileService.uploadFileByBase64(canvas.toDataURL());
          item.coverUrl = url;
          idx++;
        }
      },
      getImgs (pdsTree) {
        let groupList = pdsTree._children;
        let dataList = [];
        let pWidth = pdsTree.width, pHeight = pdsTree.height;
        groupList.forEach((node) => {
          if (!node.isGroup() || node.hidden() || node.layer.typeTool) {
            return;
          }
          if (node.parent && node.parent.name && node.parent.hidden()) {
            return;
          }
          let itemList = node.descendants();
          itemList.reverse();
          // 记录当前文件顺序
          itemList.forEach((item, index) => {
            item.index = index;
          });
          // 所有方案组统一放在一个图层，方案组的高宽才有最大图层的高宽
          let imgs = [];
          itemList.forEach((item) => {
            imgs[item.index] = { // 通过下标设置值，原数组位置经排序变动过
              type: 'img',
              name: item.name,
              left: item.left,
              top: item.top,
              width: item.width,
              height: item.height,
              url: item.toPng().src,
            };
          })
          let item = {
            widthHeight: `${pWidth}x${pHeight}`,
            name: node.name,
            projectId: this.projectId,
            templateId: this.templateId,
            coverUrl: '',
            type: group_type_pt,
            json: {
              width: pWidth,
              height: pHeight,
              data: imgs
            }
          }
          dataList.push(item);
        });
        return dataList;
      },
      getNewBoundingClientRect (itemList) {
        itemList.sort((a, b) => {
          return a.left - b.left;
        });
        let minLeft = itemList[0].left;
        itemList.sort((a, b) => {
          return a.top - b.top;
        });
        let minTop = itemList[0].top;
        itemList.forEach((item) => {
          item.newLeft = item.left - minLeft;
          item.newTop = item.top - minTop;
          item.newRight = item.newLeft + item.width;
          item.newBottom = item.newTop + item.height;
        })
        itemList.sort((a, b) => {
          return b.newRight - a.newRight;
        });
        let width = itemList[0].newRight;
        itemList.sort((a, b) => {
          return b.newTop - a.newTop;
        });
        let height = itemList[0].newBottom;
        return {
          itemList: itemList,
          width: width,
          height: height
        };
      },
      onFileRemove () {
        // history.go(0);
      },
      onFileChange (file) {
        this.loading = true;
        setTimeout(() => {
          this.onDrop({
            dataTransfer: {
              files: [file.raw]
            }
          });
        }, 200)
      },
    }
  }
</script>
<style lang="scss">
  @import "uploader.scss";
</style>